(() => {
  'use strict';

  const state = {
    measurementAllowed: false,
    optOut: true,
    sdkStarted: false,
    sdkReady: false,
    initialEventsSent: false
  };

  const measure = (eventName, data) => {
    if (
      !state.measurementAllowed ||
      !state.sdkReady ||
      typeof window.oaiq !== 'function'
    ) return;

    try {
      window.oaiq('measure', eventName, data, {
        opt_out: state.optOut
      });
    } catch (error) {
      // Tracking must never interrupt the storefront.
    }
  };

  const sendInitialEvents = () => {
    if (
      state.initialEventsSent ||
      !state.measurementAllowed ||
      !state.sdkReady
    ) return;

    state.initialEventsSent = true;

    const context = window.openAIAdsContext || {};

    measure('page_viewed', context.page || {
      type: 'contents'
    });

    if (context.product) {
      measure('contents_viewed', context.product);
    }
  };

  const syncSdkConsent = () => {
    if (!state.sdkStarted || typeof window.oaiq !== 'function') return;

    try {
      window.oaiq('consent', state.measurementAllowed);
    } catch (error) {
      // Keep the storefront working if the SDK fails.
    }
  };

  const startSdk = () => {
    if (state.sdkStarted || !state.measurementAllowed) return;

    const config = window.openAIAdsConfig || {};
    if (!config.pixelId) return;

    state.sdkStarted = true;

    if (typeof window.oaiq !== 'function') {
      const queue = function () {
        queue.q.push(arguments);
      };

      queue.q = [];
      window.oaiq = queue;
    }

    window.oaiq('consent', false);
    window.oaiq('init', {
      pixelId: config.pixelId
    });

    syncSdkConsent();

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';

    script.onload = () => {
      state.sdkReady = true;
      readShopifyConsent();
      syncSdkConsent();
      sendInitialEvents();
    };

    script.onerror = () => {
      state.sdkReady = false;
    };

    document.head.appendChild(script);
  };

  const applyConsent = (
    analyticsAllowed,
    marketingAllowed,
    saleOfDataAllowed
  ) => {
    state.measurementAllowed =
      analyticsAllowed === true &&
      marketingAllowed === true;

    state.optOut = saleOfDataAllowed !== true;

    if (!state.measurementAllowed) {
      syncSdkConsent();
      return;
    }

    startSdk();
    syncSdkConsent();
    sendInitialEvents();
  };

  function readShopifyConsent() {
    const privacy = window.Shopify &&
      window.Shopify.customerPrivacy;

    try {
      if (!privacy) {
        applyConsent(false, false, false);
        return;
      }

      applyConsent(
        privacy.analyticsProcessingAllowed(),
        privacy.marketingAllowed(),
        privacy.saleOfDataAllowed()
      );
    } catch (error) {
      applyConsent(false, false, false);
    }
  }

  document.addEventListener('visitorConsentCollected', (event) => {
    const consent = event.detail || {};

    applyConsent(
      consent.analyticsAllowed,
      consent.marketingAllowed,
      consent.saleOfDataAllowed
    );
  });

  document.addEventListener('on:cart:add', (event) => {
    readShopifyConsent();

    const form = event.target && event.target.querySelector
      ? event.target.querySelector('.js-product-form')
      : null;

    const quantityInput = form
      ? form.querySelector('[name="quantity"]')
      : null;

    const quantity = quantityInput
      ? Number.parseInt(quantityInput.value, 10)
      : 1;

    const variantId = event.detail && event.detail.variantId;

    if (!variantId) return;

    measure('items_added', {
      type: 'contents',
      contents: [{
        id: String(variantId),
        content_type: 'product',
        quantity: Number.isInteger(quantity) && quantity > 0
          ? quantity
          : 1
      }]
    });
  });

  const loadConsentApi = () => {
    readShopifyConsent();

    if (
      !window.Shopify ||
      typeof window.Shopify.loadFeatures !== 'function'
    ) return;

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      (error) => {
        if (!error) readShopifyConsent();
      }
    );
  };

  loadConsentApi();
})();